import React from 'react';
import Tile from './Tile';

type UsageTile = {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
  footer: string;
};

type UsageTilesProps = {
  onTileClick?: (tile: UsageTile) => void;
};

const TILE_ITEMS: UsageTile[] = [
  {
    id: 1,
    title: 'General Use',
    description: 'Use platform workflows for standard benchmarking and KPI insights.',
    icon: <img src="/Get_Benchmarks.png" alt="General Use" className="w-5 h-5" />,
    footer: 'Open',
  },
  {
    id: 2,
    title: 'Account-Level Use',
    description: 'Run account-focused journeys to evaluate a specific company context.',
    icon: <img src="/Compare_a_Company.png" alt="Account-Level Use" className="w-5 h-5" />,
    footer: 'Open',
  },
  {
    id: 3,
    title: 'Contibute data',
    description: 'Share your data securely to enrich the collective private equity dataset.',
    icon: <img src="/Contribute_Deal_Data.png" alt="Contibute data" className="w-5 h-5" />,
    footer: 'Open',
  },
];

function UsageTiles({ onTileClick }: UsageTilesProps) {
  const primaryTiles = TILE_ITEMS.filter((tile) => tile.id !== 3);
  const contributeTile = TILE_ITEMS.find((tile) => tile.id === 3);

  return (
    <div className="min-h-screen bg-[#f4fbf6] dark:bg-gray-950 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full bg-emerald-200/30 blur-3xl" />
      <div className="pointer-events-none absolute -top-40 -right-32 w-[440px] h-[440px] rounded-full bg-sky-200/25 blur-3xl" />
      <div className="pointer-events-none absolute bottom-40 right-1/4 w-[380px] h-[380px] rounded-full bg-indigo-200/20 blur-3xl" />

      <div className="relative z-10">
        <div className="text-center py-16">
          <h2 className="text-4xl font-bold text-green-600 dark:text-white mb-3 tracking-tight">Welcome!</h2>
          <p className="text-lg text-black-600 dark:text-gray-300 max-w-2xl mx-auto">Select what you would like to do.</p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-5xl mx-auto">
            {primaryTiles.map((tile) => (
              <Tile
                key={tile.id}
                icon={tile.icon}
                title={tile.title}
                description={tile.description}
                footer={tile.footer}
                onClick={() => onTileClick && onTileClick(tile)}
              />
            ))}
          </div>

          {contributeTile && (
            <div className="mt-16 flex justify-center">
              <button
                type="button"
                onClick={() => onTileClick && onTileClick(contributeTile)}
                className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 dark:text-emerald-400 hover:text-emerald-900 dark:hover:text-emerald-200 transition-colors underline-offset-4 hover:underline"
              >
                <img src="/Contribute_Deal_Data.png" alt="" className="w-4 h-4 shrink-0" />
                Contribute Data
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default UsageTiles;